import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { 
  Calendar, FileText, FileBadge,
  Users, CheckCircle, AlertCircle 
} from 'lucide-react';

export const HR = () => {
  const { user, isAdmin } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isAdmin) {
      fetchStats();
    } else {
      setLoading(false);
    }
  }, [isAdmin]);

  const fetchStats = async () => {
    try {
      const response = await api.get('/hr/stats');
      setStats(response.data);
    } catch (error) {
      console.error('Errore stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const menuItems = [
    { icon: Calendar, label: 'Gestione Ferie', path: '/hr/ferie', color: 'blue', desc: 'Richieste e approvazioni' },
    { icon: FileText, label: 'Buste Paga e CUD', path: '/hr/buste-paga', color: 'green', desc: 'Upload con AI, summary e download' },
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="p-3 sm:p-6 md:p-8 lg:p-10">
      <div className="mb-8">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 tracking-tight mb-2">
          Sistema HR
        </h1>
        <p className="text-base text-slate-600">
          {isAdmin ? 'Gestione Risorse Umane' : 'Le tue informazioni HR'}
        </p>
      </div>

      {isAdmin && stats && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-xl border border-slate-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 rounded-lg bg-orange-50">
                <AlertCircle size={24} className="text-orange-600" />
              </div>
            </div>
            <p className="text-3xl font-bold text-slate-900 mb-1">{stats.ferie_in_attesa}</p>
            <p className="text-sm text-slate-600">Ferie in Attesa</p>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 rounded-lg bg-green-50">
                <CheckCircle size={24} className="text-green-600" />
              </div>
            </div>
            <p className="text-3xl font-bold text-slate-900 mb-1">{stats.ferie_approvate_mese}</p>
            <p className="text-sm text-slate-600">Ferie Approvate</p>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 rounded-lg bg-blue-50">
                <Users size={24} className="text-blue-600" />
              </div>
            </div>
            <p className="text-3xl font-bold text-slate-900 mb-1">{stats.dipendenti_totali}</p>
            <p className="text-sm text-slate-600">Dipendenti</p>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 rounded-lg bg-purple-50">
                <FileText size={24} className="text-purple-600" />
              </div>
            </div>
            <p className="text-3xl font-bold text-slate-900 mb-1">{stats.buste_paga_caricate}</p>
            <p className="text-sm text-slate-600">Buste Paga</p>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="bg-white rounded-xl border border-slate-200 p-6 hover:shadow-lg hover:border-blue-300 transition-all group"
          >
            <div className={`p-4 rounded-xl bg-${item.color}-50 inline-block mb-4 group-hover:scale-110 transition-transform`}>
              <item.icon size={32} className={`text-${item.color}-600`} />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2">{item.label}</h3>
            <p className="text-sm text-slate-600">{item.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};
